export const CHAIN_META = {
  1: { name: 'Ethereum Mainnet', hex: '0x1' },
  11155111: { name: 'Sepolia', hex: '0xaa36a7' },
  31337: { name: 'Hardhat', hex: '0x7a69' },
};

export function getTargetChainId() {
  const target = (import.meta.env.VITE_RPC_TARGET || 'localhost').toLowerCase();

  if (target === 'sepolia') return 11155111;
  if (target === 'mainnet') return 1;
  return 31337;
}

export function getTargetName() {
  const id = getTargetChainId();
  return CHAIN_META[id]?.name || `Chain ${id}`;
}

export function chainName(chainId) {
  return CHAIN_META[chainId]?.name || (chainId ? `Chain ${chainId}` : 'Not connected');
}
